import {
    Box,
    Grid,
    Typography,
    TextField,
    Checkbox,
    FormControlLabel,
    MenuItem,
    Button,
    FormControl,
    InputLabel,
    Select,
    IconButton,
    Alert,
    CircularProgress,
    Tooltip
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import SectionHeader from '../../../components/SectionHeader';
import DrawerVisitas from '../components/DrawerVisitas';
import SobreSiniestroDrawer from './components/SobreSiniestroDrawer';
import EjecucionRecomendacionesSection from './components/EjecucionRecomendacionesSection';
import { useEjecutionsVisits } from './hooks/useEjecutionVisits';
import { DialogNewRGRL } from '../../Presentaciones/components/DialogNewRGRL';
import { useNavigate } from 'react-router-dom';
import VerosimilitudSection from './components/VerosimilitudSection';
import RGRLSection from './components/RGRLSection';
import { DRAWER_ACTION_VALUES } from '../components/drawers/DrawerManager';
import { SendVisitToRevisionDrawer } from '../components/drawers/SendVisitToRevisionDrawer';
import { DrawerContainer } from '../../../components/Drawer/DrawerContainer';
import { useSnackbar } from 'notistack';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    useDeleteAdditionalDocumentoMutation,
    useDownloadTechnicalVisitPdfMutation,
    useDownloadActividadDocumentoMutation,
    usePresentActivityRgrlMutation,
    usePresentActivityVerosimilitudMutation,
    usePresentVisitMutation,
    useUploadAdditionalDocumentMutation
} from '../../../services/visitasApi';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useEffect, useRef, useState } from 'react';
import { showAlert } from '../../../features/slices/applicationSlice';
import { useAppDispatch } from '../../../hooks/reduxHooks';
import { ActividadItem, ActivityActionsMenu } from './components/ActivityActionsMenu';
import { SquareIconButton } from '../../../components/Icons/SquareIconButton';
import BackdropComponent from '../../../components/Backdrop/BackdropComponent';
import { useDownloadVisitaActaMutation } from '../../../services/visitasApi';
import { useLocation } from 'react-router-dom';
import useVisitas from '../hooks/useVisitas';
import AlertComponent from '../../../components/AlertMessage/AlertMessage';
import SignatureExtraFields from './components/SignatureExtraFields';
import MotivoFallaSelector from './components/MotivoFallaSelector';
import ActivitySummaryChip from './components/ActivitySummaryChip';
import { CommonMimeType, downloadBase64File } from '../../../utils/base64FileDownload';
import { getApiErrorMessage } from '../../../utils/apiError';
import { buildActaInterviewedData } from '../utils/actaPayload';
import { useRoles } from '../../../hooks/useRoles';
import { validationRules } from '../../../components/CustomFormsComponents/hooks/useValidation';
import { INTERVIEWED_FIELDS } from './validations/interviewedFields';
import { esEstadoDescargaActaPermitido, VisitaEstado } from '../consts/visitasStatus';
import {
    VISIT_TYPE_DISPLAY_NAME_OVERRIDES,
    VisitTypeId
} from '../consts/visitTypeDisplayNames';
import { useDescargaActaSiniestro } from './hooks/useDescargaActaSiniestro';
import {
    INVESTIGACION_VISIT_TYPE_IDS,
    puedeDescargarPdfInvestigacion
} from '../consts/pdfInvestigacion';
import { useDescargaPdfInvestigacionVisita } from '../hooks/useDescargaPdfInvestigacionVisita';
import { VisitaEstadoChip } from '../components/EstadoChip';
import { buildResponsableFacsimileImage, RESPONSABLE_FACSIMILE_IMAGES } from '../utils/facsimileSignature';
import { resolveEstablishmentCondition } from '../../../constants/establishmentOriginLegend';
import { isAutoseguro } from '../../../constants/organizationLegends';

const TECHNICAL_VISIT_TYPE_ID = 466;
const SHOW_TECHNICAL_VISIT_ACTIVITY = true;
const OBSERVATION_MAX_LENGTH = 4000;
const HEADER_OBSERVATION_PREVIEW_LENGTH = 180;
const ACTIVITY_STATUS_PENDING = 1;
function EjecutionsVisitsIndex() {
    const { t } = useTranslation('visitas');
    const { t: tValidations } = useTranslation('validations');
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { isAdminBO, isProvider, isViewerBO, isPreventor, isSupervisorSIMP } = useRoles();

    const {
        formData,
        setFormData,
        isFormValid,
        handleChange,
        handleFalloVisitaChange,
        handleSubmit,
        handleSaveInProgress,
        handleClearSignature,
        openDrawer,
        setOpenDrawer,
        handleOpenDrawer,
        selectedVisita,
        selectedVisitaDetail,
        canvasPreventorRef,
        canvasResponsableRef,
        tiposVisitasOptions,
        subTypesVisitasOptions,
        loadingTiposVisitas,
        motivosFallaOptions,
        loadingMotivosFalla,
        signatureErrors,
        confirmSubmit,
        rgrlPresentaciones,
        openDialogRGRL,
        handleOpenDialogRGRL,
        handleCloseDialogRGRL,
        handleCardClickRGRL,
        handleOpenVerosimilitud,
        loadingPresentaciones,
        shouldShowVerosimilitudRow,
        isVerosimilitudDraft,
        confirmCancelPresentation,
        allPresentationsCancelled,
        handleEditRGRL,
        hasRgrlPresentations,
        isVerosimilitudPendienteSinRespuestas,
        loadingVerosimilitud,
        handleNoInformaChange,
        loadingAdditionalDocs,
        additionalDocuments,
        getTipoActividad,
        refetchVisita,
        disableInteraction,
        isSavingInProgress,
        isFailedVisitByState,
        initPreventorSignaturePad,
        initResponsableSignaturePad,
        drawerSiniestroAbierto,
        abrirDrawerSiniestro,
        cerrarDrawerSiniestro,
        datosSiniestro,
        cargandoSiniestro,
        errorSiniestro,
        readOnlySrt,
        esVisitaInvestigacion,
        esSeguimientoVerosimilitud,
        isCPEOrganismo,
        facsimileOrganismoKey,
        establecimientoDetalle
    } = useEjecutionsVisits();

    const { enqueueSnackbar } = useSnackbar();
    const [uploadDocument] = useUploadAdditionalDocumentMutation();
    const [downloadTechnicalVisitPdf] = useDownloadTechnicalVisitPdfMutation();
    const [downloadDocumento] = useDownloadActividadDocumentoMutation();
    const [deleteAdditionalDocumento] = useDeleteAdditionalDocumentoMutation();
    const [isDownloadingAdditional, setIsDownloadingAdditional] = useState(false);
    const [isDeletingAdditional, setIsDeletingAdditional] = useState(false);
    const [isUploadDocumentAditional, setIsUploadDocumentAditional] = useState(false);
    const [activitiesCompletion, setActivitiesCompletion] = useState<Record<number, boolean>>({});
    const [rgrlAlreadyPresented, setRgrlAlreadyPresented] = useState(false);
    const [isVerosimilitudRecibido, setIsVerosimilitudRecibido] = useState(false);
    const [verosimilitudAlreadyPresented, setVerosimilitudAlreadyPresented] = useState(false);
    const [editPreventorSignature, setEditPreventorSignature] = useState(false);
    const [editResponsableSignature, setEditResponsableSignature] = useState(false);
    const [isHeaderObservationExpanded, setIsHeaderObservationExpanded] = useState(false);
    const [submitAttempted, setSubmitAttempted] = useState(false);

    const [downloadActa, setDownloadActa] = useState(false);
    const [downloadVisitaActa] = useDownloadVisitaActaMutation();
    const [isDownloadingActa, setIsDownloadingActa] = useState(false);
    const { puedeDescargarActaSiniestro, descargandoActaSiniestro, descargarActaSiniestro } =
        useDescargaActaSiniestro(selectedVisita);
    const { descargandoPdfInvestigacion, descargarPdfInvestigacion } =
        useDescargaPdfInvestigacionVisita();
    const [isDownloadingTechnicalVisit, setIsDownloadingTechnicalVisit] = useState(false);
    const location = useLocation();
    const initPreventorSignaturePadRef = useRef(initPreventorSignaturePad);
    const initResponsableSignaturePadRef = useRef(initResponsableSignaturePad);
    const siniestro = selectedVisita?.siniestro || location.state?.siniestro;
    const siniestroNumber = siniestro?.nroRoam || siniestro?.numero || siniestro?.nroSiniestro || siniestro?.id;
    // El supervisor consulta la ejecución en solo lectura (SMP-459).
    const isReadOnlyRole = Boolean(isProvider) || Boolean(isViewerBO) || Boolean(isSupervisorSIMP);
    const isReadOnlyView = disableInteraction || isReadOnlyRole || Boolean(location.state?.fromVisitaOrigen);
    const effectiveReadOnlySrt = readOnlySrt || isReadOnlyRole;
    const isFailedVisit = isFailedVisitByState || formData.esFallida;
    const headerObservation = selectedVisita?.observacionAlta?.trim() || '';
    const selectedVisitaInterviewedData = {
        nombreEntrevistado:
            selectedVisita?.nombreEntrevistado ?? selectedVisita?.entrevistado?.nombre ?? '',
        dniEntrevistado: selectedVisita?.dniEntrevistado ?? selectedVisita?.entrevistado?.dni ?? '',
        caracterEntrevistado:
            selectedVisita?.caracterEntrevistado ?? selectedVisita?.entrevistado?.caracter ?? '',
        telefonoEntrevistado:
            selectedVisita?.telefonoEntrevistado ?? selectedVisita?.entrevistado?.telefono ?? '',
        emailEntrevistado:
            selectedVisita?.emailEntrevistado ?? selectedVisita?.entrevistado?.email ?? ''
    };
    const shouldTruncateHeaderObservation =
        headerObservation.length > HEADER_OBSERVATION_PREVIEW_LENGTH;
    const displayedHeaderObservation =
        shouldTruncateHeaderObservation && !isHeaderObservationExpanded
            ? `${headerObservation.slice(0, HEADER_OBSERVATION_PREVIEW_LENGTH)}...`
            : headerObservation;
    const formatDateOrDash = (date?: string | null) =>
        date ? dayjs.utc(date).format('DD/MM/YYYY') : '-';
    const formatTextOrDash = (value?: string | number | null) =>
        value !== undefined && value !== null && String(value).trim() !== '' ? String(value) : '-';
    const getLocalidadProvincia = () => {
        const localidad =
            establecimientoDetalle?.direccion?.localidad?.nombre ||
            selectedVisita?.establecimiento?.direccion?.localidad?.nombre ||
            selectedVisita?.establecimiento?.localidad?.nombre ||
            selectedVisita?.localidad?.nombre ||
            selectedVisita?.localidad;
        const provincia =
            establecimientoDetalle?.direccion?.localidad?.provincia?.nombre ||
            selectedVisita?.establecimiento?.direccion?.localidad?.provincia?.nombre ||
            selectedVisita?.establecimiento?.localidad?.provincia?.nombre ||
            selectedVisita?.provincia?.nombre ||
            selectedVisita?.provincia;

        return [localidad, provincia].filter(Boolean).join(' / ') || '-';
    };
    const getCliente = () =>
        establecimientoDetalle?.cliente?.nombre ||
        selectedVisita?.establecimiento?.cliente?.nombre ||
        selectedVisita?.cliente?.nombre ||
        selectedVisita?.organizacion?.nombre ||
        selectedVisita?.nombreCliente ||
        // Fallback para visitas ligadas a un siniestro ROAM que no traen cliente por ninguna de
        // las fuentes de arriba: GET /visitas/{id}/siniestro sí lo trae como empleadorRazonSocial.
        datosSiniestro?.empleadorRazonSocial ||
        '-';
    // Los datos del siniestrado salen de GET /visitas/{id}/siniestro; mientras carga, o si
    // falla, se usa el empleado que ya viene mapeado en la visita.
    const getNombreSiniestrado = () => {
        if (!siniestro?.id) return null;
        const nombreDetalle = [datosSiniestro?.nombre, datosSiniestro?.apellido].filter(Boolean).join(' ');
        return nombreDetalle || siniestro?.empleado?.nombreCompleto;
    };
    const getCuilSiniestrado = () =>
        siniestro?.id ? datosSiniestro?.cuil || siniestro?.empleado?.cuil : null;
    const getPreventor = () =>
        selectedVisita?.nombrePreventor ||
        (selectedVisita?.preventor
            ? `${selectedVisita.preventor.nombre ?? ''} ${selectedVisita.preventor.apellido ?? ''}`.trim()
            : '') ||
        '-';
    const getReturnMotive = () =>
        selectedVisita?.motivoDevolucionBackoffice ||
        selectedVisita?.motivoDevolucion ||
        selectedVisita?.observacionDevolucion ||
        selectedVisita?.observacionRevision ||
        selectedVisita?.ultimoEvento?.detalle?.nota ||
        selectedVisita?.detalleDevolucion?.motivo ||
        '';
    const backofficeReturnMotive = getReturnMotive();
    // Los comentarios de corrección de BackOffice al preventor son internos del circuito de
    // revisión: el Supervisor no los ve (SMP-635).
    const showComentariosBackoffice = !isSupervisorSIMP;
    const showBackofficeReturnBanner =
        showComentariosBackoffice &&
        isReadOnlyRole &&
        selectedVisita?.estado === VisitaEstado.EN_PROCESO &&
        Boolean(backofficeReturnMotive?.trim());
    // "Solicitar cambios / Devolver" guarda el motivo como observación de revisión y
    // como nota de devolución: la nota solo se muestra si no repite el motivo que ya
    // se ve en el banner anterior (SMP-583).
    const notaDevolucion = selectedVisita?.notaDevolucion?.trim();
    const motivoYaMostrado = (
        showBackofficeReturnBanner ? backofficeReturnMotive : selectedVisita?.observacionRevision
    )?.trim();
    const showNotaDevolucion =
        showComentariosBackoffice &&
        Boolean(notaDevolucion) &&
        notaDevolucion !== motivoYaMostrado;
    const showObservacionesBackoffice =
        showComentariosBackoffice &&
        !showBackofficeReturnBanner &&
        Boolean(selectedVisita?.observacionRevision?.trim());

    const canSignPreventor = !isReadOnlyView;
    // En una visita fallida el responsable puede firmar, pero no es obligatorio.
    const canSignResponsable = !isReadOnlyView;
    // Si la visita todavia no tiene su propia firma persistida, formData.firmaPreventor puede
    // traer precargada la firma del perfil del preventor (una URL), lista para mostrarse igual
    // que una ya guardada pero editable via el boton "Editar".
    const preventorSignatureImageSrc =
        selectedVisita?.firmaPreventor ||
        (isPreventor && /^https?:\/\//.test(formData.firmaPreventor ?? '')
            ? formData.firmaPreventor
            : '');
    const hasPreventorSignatureImage = Boolean(preventorSignatureImageSrc);
    const hasResponsableSignatureImage = Boolean(selectedVisita?.firmaResponsable);
    const puedeDescargarActaSeguimientoVerosimilitud =
        esSeguimientoVerosimilitud &&
        Boolean(
            selectedVisita?.actividades?.some(
                (a: any) => a?.tipoVisita?.id === 473 && a?.estado === 2
            )
        );
    const hasRegisteredActa = Boolean(
        selectedVisita?.fechaVisita ||
            selectedVisita?.observacion ||
            selectedVisita?.firmaPreventor ||
            selectedVisita?.firmaResponsable
    );

    const showPreventorImage = hasPreventorSignatureImage && !editPreventorSignature;

    // Al cargar una fallida el responsable firma en el canvas o no firma: no se muestra la firma
    // que ya tuviera la visita ni el facsímil, porque no se mandan (SMP-416).
    const firmaResponsableEnCanvasFallida = formData.esFallida && !isReadOnlyView;

    const showResponsableImage =
        hasResponsableSignatureImage && !editResponsableSignature && !firmaResponsableEnCanvasFallida;

    useEffect(() => {
        refetchVisita();
    }, [location.key, refetchVisita]);

    useEffect(() => {
        setIsHeaderObservationExpanded(false);
    }, [selectedVisita?.id]);

    useEffect(() => {
        initPreventorSignaturePadRef.current = initPreventorSignaturePad;
    }, [initPreventorSignaturePad]);

    useEffect(() => {
        initResponsableSignaturePadRef.current = initResponsableSignaturePad;
    }, [initResponsableSignaturePad]);

    const allActivities =
        selectedVisita?.actividades?.map((a: any) => a?.tipoVisita?.descripcion?.toUpperCase()) ||
        [];
    const [presentActivityRgrl, { isLoading: isPresentingRgrl }] = usePresentActivityRgrlMutation();
    const [presentActivityVerosimilitud, { isLoading: isPresentingVerisimilitud }] =
        usePresentActivityVerosimilitudMutation();
    const [presentVisit, { isLoading: isApprovingVisit }] = usePresentVisitMutation();

    const handleApproveVisit = async () => {
        try {
            await presentVisit({ visitId: selectedVisita.id }).unwrap();
            refetchVisita();
            enqueueSnackbar(t('execution.snackbar.approveVisitSuccess'), { variant: 'success' });
        } catch {
            enqueueSnackbar(t('execution.snackbar.approveVisitError'), { variant: 'error' });
        }
    };

    const handleApproveVisitClick = () => {
        dispatch(
            showAlert({
                icon: 'info',
                title: t('alerts.present.title'),
                message: t('alerts.present.message'),
                confirmText: t('alerts.present.confirmText'),
                cancelText: t('alerts.present.cancelText'),
                confirmAction: handleApproveVisit
            })
        );
    };

    // "Solicitar cambios / Devolver" abre el drawer de envío al preventor (SMP-583).
    const [isSendToPreventorOpen, setIsSendToPreventorOpen] = useState(false);

    const rgrlActivity = selectedVisita?.actividades?.find(
        (a: any) => a.tipoVisita?.descripcion?.toUpperCase() === 'RGRL'
    );
    const isRgrlPending = rgrlActivity?.estado === 1;
    const isRgrlPresented = Boolean(selectedVisita?.rgrl?.id) || rgrlActivity?.estado === 2;

    const verosimilitudActivity = selectedVisita?.actividades?.find(
        (a: any) => a.tipoVisita?.descripcion?.toUpperCase() === 'VEROSIMILITUD'
    );
    const idVerosimilitud = selectedVisita?.verosimilitud?.id;

    const hasVerosimilitudEntity = Boolean(selectedVisita?.verosimilitud?.id);

    const isVerosimilitudPresented = hasVerosimilitudEntity;

    const isVerosimilitudPending = verosimilitudActivity?.estado === 1;

    const hasPreventorSignature = Boolean(formData.firmaPreventor);
    const hasResponsableSignature = isCPEOrganismo || Boolean(formData.firmaResponsable);
    const allActivitiesCompleted =
        Object.values(activitiesCompletion).length > 0 &&
        Object.values(activitiesCompletion).every(Boolean);

    const isVerosimilitud = allActivities.includes('VEROSIMILITUD');
    const isRgrl = allActivities.includes('RGRL');
    const technicalVisitActivity = selectedVisita?.actividades?.find(
        (actividad: any) => actividad?.tipoVisita?.id === TECHNICAL_VISIT_TYPE_ID
    );
    const hasTechnicalVisit = SHOW_TECHNICAL_VISIT_ACTIVITY && Boolean(technicalVisitActivity);
    const isTechnicalVisitDone = technicalVisitActivity?.estado === 2;
    const idVisitaTecnica: number | null =
        selectedVisita?.idVisitaTecnica ??
        selectedVisita?.visitaTecnica?.id ??
        selectedVisita?.technicalVisit?.id ??
        null;
    // Informe de investigacion (SMP-401): Preventor y Admin BO, visita de investigacion aprobada.
    const puedeDescargarPdfInvestigacionVisita = puedeDescargarPdfInvestigacion(
        selectedVisita,
        isPreventor || isAdminBO || isSupervisorSIMP
    );
    const investigacionActivity = selectedVisita?.actividades?.find(
        (actividad: any) => INVESTIGACION_VISIT_TYPE_IDS.includes(actividad?.tipoVisita?.id)
    );
    const [isRgrlRecibido, setIsRgrlRecibido] = useState(false);
    const hasValidRgrl = !isRgrl || isRgrlRecibido || rgrlAlreadyPresented;
    const hasValidTechnicalVisit = !hasTechnicalVisit || isTechnicalVisitDone;
    const renderableOtherActivities =
        selectedVisita?.actividades?.filter((a: any) => {
            const activityName = a?.tipoVisita?.descripcion?.toUpperCase() ?? '';
            if (
                a?.tipoVisita?.id === TECHNICAL_VISIT_TYPE_ID ||
                INVESTIGACION_VISIT_TYPE_IDS.includes(a?.tipoVisita?.id) ||
                ['VEROSIMILITUD', 'RGRL'].includes(activityName)
            ) {
                return false;
            }

            return (getTipoActividad(a?.tipoVisita?.id)?.tiposArchivo?.length ?? 0) > 0;
        }) || [];
    const shouldShowActivitiesSection =
        isVerosimilitud || isRgrl || hasTechnicalVisit || esVisitaInvestigacion || renderableOtherActivities.length > 0;
    const isSimpleVisit =
        Array.isArray(selectedVisita?.actividades) && selectedVisita.actividades.length === 1;
    const isMultipleVisit =
        Array.isArray(selectedVisita?.actividades) && selectedVisita.actividades.length > 1;
    const areAllActivitiesPending =
        Array.isArray(selectedVisita?.actividades) &&
        selectedVisita.actividades.length > 0 &&
        selectedVisita.actividades.every(
            (actividad: any) => Number(actividad?.estado) === ACTIVITY_STATUS_PENDING
        );
    const shouldUpdateFechaVisitaOnDocumentUpload =
        isSimpleVisit || (isMultipleVisit && areAllActivitiesPending);
    const getFileName = (path: string) =>
        path?.split('/').pop() ?? String(t('execution.detail.documentFallback'));

    const hasRegularActivities = Object.keys(activitiesCompletion).length > 0;

    const handleOpenTechnicalVisit = (mode: 'create' | 'edit' | 'view' = 'edit') => {
        navigate('./visita-tecnica', {
            state: {
                mode,
                selectedVisita,
                selectedEstablishmentId:
                    selectedVisita?.idEstablecimiento || selectedVisita?.establecimiento?.id
            }
        });
    };

    const handleAbrirFormularioSRT = () => {
        navigate('./formulario-srt', { state: { selectedVisita, fromVisitasRoam: location.state?.fromVisitasRoam, datosSiniestro } });
    };

    const handleAbrirSeguimientoVerosimilitud = () => {
        navigate('./seguimiento-verosimilitud', {
            state: {
                selectedVisita,
                idSeguimientoVisita: selectedVisita?.id,
                idVisitaOrigen: selectedVisita?.visitaOriginal?.id ?? null,
                idVerosimilitud: selectedVisita?.visitaOriginal?.verosimilitud?.id ?? null
            }
        });
    };

    const handleDownloadTechnicalVisit = async () => {
        if (!selectedVisita?.id) return;

        try {
            setIsDownloadingTechnicalVisit(true);
            const response = (await downloadTechnicalVisitPdf({
                idVisita: selectedVisita.id
            }).unwrap()) as Blob | { data?: string } | string;

            if (response instanceof Blob) {
                const url = window.URL.createObjectURL(response);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `visita-tecnica_${selectedVisita.id}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                return;
            }

            const base64Data =
                typeof response === 'string'
                    ? response
                    : typeof (response as { data?: string })?.data === 'string'
                      ? response.data
                      : '';

            if (!base64Data) {
                throw new Error('Invalid PDF response');
            }

            downloadBase64File({
                base64Data,
                fileName: `visita-tecnica_${selectedVisita.id}.pdf`,
                mimeType: CommonMimeType.PDF
            });
        } catch (error: any) {
            enqueueSnackbar(getApiErrorMessage(error, t('technicalVisit.form.downloadError')), {
                variant: 'error'
            });
        } finally {
            setIsDownloadingTechnicalVisit(false);
        }
    };

    const hasPreventorExtraFields =
        Boolean(formData.aclaracionPreventor?.trim()) &&
        Boolean(formData.dniPreventor?.trim()) &&
        Boolean(formData.cargoPreventor?.trim());

    const hasFailedVisitMotivo = formData.idMotivoFallaVisita !== null && formData.idMotivoFallaVisita !== undefined;

    const hasFailedVisitObservacion = Boolean(formData.observacion?.trim());

    const hasResponsableExtraFields =
        Boolean(formData.aclaracionResponsable?.trim()) &&
        Boolean(formData.dniResponsable?.trim()) &&
        Boolean(formData.cargoResponsable?.trim());
    const formDataByName = formData as Record<string, any>;
    const interviewedValidationRules = validationRules(tValidations);

    // Serv. HyS: Matricula y Email son obligatorios con servicio, salvo que se marque "No Informa".
    // Sin servicio los campos no aplican y se muestran con "-".
    const conServicioHyS = formData.seguridadHigiene === true;
    const sinServicioHyS = formData.seguridadHigiene === false;
    const faltaMatricula =
        conServicioHyS && !formData.matriculaNoInforma && !formData.matricula?.trim();
    const errorEmailHys = (() => {
        if (!conServicioHyS || formData.emailHysNoInforma) return '';
        if (!formData.emailHys?.trim()) return 'Campo requerido';
        return interviewedValidationRules.email(formData.emailHys.trim());
    })();
    const formatHySReadOnly = (valor?: string | null, noInforma?: boolean) =>
        noInforma ? t('newVisit.label.notInformed') : formatTextOrDash(valor);
    const interviewedFieldErrors = INTERVIEWED_FIELDS.reduce<Record<string, string>>(
        (acc, field) => {
            const value = formDataByName[field.name] ?? '';
            const error = field.validations
                .map((validation) =>
                    interviewedValidationRules[validation.name](
                        value,
                        validation.param,
                        validation.errorMessage
                    )
                )
                .find(Boolean);

            if (error) {
                acc[field.name] = error;
            }

            return acc;
        },
        {}
    );
    const missingInterviewedFields = INTERVIEWED_FIELDS.filter(
        ({ name }) => interviewedFieldErrors[name] === tValidations('validation.required')
    );
    const interviewedFormatErrors = INTERVIEWED_FIELDS.filter(
        ({ name }) =>
            Boolean(interviewedFieldErrors[name]) &&
            interviewedFieldErrors[name] !== tValidations('validation.required')
    );
    const interviewedFieldError = (name: string) => {
        const error = interviewedFieldErrors[name] ?? '';
        return formData.esFallida && error === tValidations('validation.required') ? '' : error;
    };
    const hasInterviewedData = missingInterviewedFields.length === 0;
    const hasValidInterviewedData =
        hasInterviewedData && interviewedFormatErrors.length === 0;

    // En la fallida, quien recibió al preventor es opcional (SMP-416): no se exige, pero lo que
    // se cargue tiene que tener formato válido. La observación sí es obligatoria (SMP-546).
    const hasFailedVisitRequirements =
        hasPreventorSignature &&
        hasPreventorExtraFields &&
        hasFailedVisitMotivo &&
        hasFailedVisitObservacion &&
        interviewedFormatErrors.length === 0;

    const hasNormalVisitRequirements =
        isFormValid &&
        (!hasRegularActivities || allActivitiesCompleted) &&
        hasPreventorSignature &&
        hasResponsableSignature &&
        hasPreventorExtraFields &&
        hasResponsableExtraFields &&
        hasValidInterviewedData &&
        hasValidRgrl &&
        hasValidTechnicalVisit;

    const canSubmit = isFailedVisit ? hasFailedVisitRequirements : hasNormalVisitRequirements;

    const getSubmitValidationErrors = () => {
        const errors: string[] = [];

        if (isFailedVisit) {
            if (!hasFailedVisitMotivo) {
                errors.push('Debe seleccionar un motivo de falla.');
            }

            if (!hasPreventorSignature) {
                errors.push('Debe cargar la firma del preventor.');
            }

            if (!hasPreventorExtraFields) {
                errors.push('Debe completar aclaracion, DNI y cargo del preventor.');
            }

            if (!hasFailedVisitObservacion) {
                errors.push('Debe completar la observación.');
            }

            interviewedFormatErrors.forEach(({ labelKey, name }) => {
                errors.push(`${t(labelKey)}: ${interviewedFieldErrors[name]}`);
            });

            return errors;
        }

        if (!isFormValid) {
            errors.push('Debe completar los datos obligatorios de la visita.');
        }

        if (hasRegularActivities && !allActivitiesCompleted) {
            errors.push('Debe completar las actividades requeridas.');
        }

        if (!hasPreventorSignature) {
            errors.push('Debe cargar la firma del preventor.');
        }

        if (!hasResponsableSignature) {
            errors.push('Debe cargar la firma del responsable.');
        }

        if (!hasPreventorExtraFields) {
            errors.push('Debe completar aclaracion, DNI y cargo del preventor.');
        }

        if (!hasResponsableExtraFields) {
            errors.push('Debe completar aclaracion, DNI y cargo del responsable.');
        }

        if (!hasInterviewedData) {
            errors.push(
                `${t('execution.interviewed.missingFields')}: ${missingInterviewedFields
                    .map(({ labelKey }) => t(labelKey))
                    .join(', ')}.`
            );
        }

        if (interviewedFormatErrors.length > 0) {
            interviewedFormatErrors.forEach(({ labelKey, name }) => {
                errors.push(`${t(labelKey)}: ${interviewedFieldErrors[name]}`);
            });
        }

        if (formData.seguridadHigiene === true) {
            if (!formData.profesional?.trim()) {
                errors.push(`${t('newVisit.label.professional')}: campo requerido.`);
            }
            if (faltaMatricula) {
                errors.push(`${t('newVisit.label.license')}: campo requerido.`);
            }
            if (errorEmailHys) {
                errors.push(`${t('newVisit.label.hysEmail')}: ${errorEmailHys.toLowerCase()}.`);
            }
        }

        if (!hasValidRgrl) {
            errors.push(
                `Debe completar o recibir ${VISIT_TYPE_DISPLAY_NAME_OVERRIDES[VisitTypeId.RGRL]}.`
            );
        }

        if (!hasValidTechnicalVisit) {
            errors.push('Debe completar la Visita Tecnica.');
        }

        return errors;
    };

    const handleConfirmSubmitClick = () => {
        setSubmitAttempted(true);
        const validationErrors = getSubmitValidationErrors();

        if (validationErrors.length > 0) {
            enqueueSnackbar(
                <Box component="ul" sx={{ m: 0, pl: 2 }}>
                    {validationErrors.map((error) => (
                        <Box component="li" key={error}>
                            {error}
                        </Box>
                    ))}
                </Box>,
                {
                    variant: 'error',
                    autoHideDuration: 8000
                }
            );
            return;
        }

        confirmSubmit();
    };

    const shouldPresentVerosimilitudActivity = ({
        isVerosimilitud,
        isVerosimilitudPresented,
        verosimilitudActivity,
        isVerosimilitudPending,
        verosimilitudAlreadyPresented
    }: {
        isVerosimilitud: boolean;
        isVerosimilitudPresented: boolean;
        verosimilitudActivity?: any;
        isVerosimilitudPending: boolean;
        verosimilitudAlreadyPresented: boolean;
    }) =>
        isVerosimilitud &&
        isVerosimilitudPresented &&
        !!verosimilitudActivity?.id &&
        isVerosimilitudPending &&
        !verosimilitudAlreadyPresented;

    useEffect(() => {
        if (!downloadActa || !selectedVisita) return;

        const downloadBlankActa = async () => {
            setIsDownloadingActa(true);

            try {
                // Con la visita en curso se pide el acta para rellenar a mano
                // (blank): el back no genera el acta completa hasta que la
                // visita se realiza. En solo lectura se baja la completa.
                const response = await downloadVisitaActa({
                    idVisita: selectedVisita.id,
                    idTipoVisita:
                        selectedVisita.idTipoVisita ??
                        selectedVisita.actividades?.[0]?.tipoVisita?.id,
                    tipoActa: 1,
                    blank: !isReadOnlyView,
                    datos: buildActaInterviewedData(selectedVisita)
                }).unwrap();

                if (response?.data) {
                    const byteCharacters = atob(response.data);
                    const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
                    const blob = new Blob([new Uint8Array(byteNumbers)], {
                        type: 'application/pdf'
                    });

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = 'Acta_Visita.pdf';
                    link.click();
                    window.URL.revokeObjectURL(url);
                }
            } catch {
                enqueueSnackbar(t('alerts.downloadActa.error'), {
                    variant: 'error'
                });
            } finally {
                setIsDownloadingActa(false);
                setDownloadActa(false);
            }
        };

        downloadBlankActa();
    }, [downloadActa, selectedVisita, downloadVisitaActa, enqueueSnackbar, t, isReadOnlyView]);

    const confirmUploadAdditionalDoc = (file: File) => {
        dispatch(
            showAlert({
                icon: 'info',
                title: t('execution.alerts.confirmUploadDocument.title'),
                message: t('execution.alerts.confirmUploadDocument.message', {
                    fileName: file.name
                }),
                confirmText: t('execution.alerts.confirmUploadDocument.confirmText'),
                cancelText: t('buttons.cancel'),
                itemData: true,
                confirmAction: () => handleUploadAdditionalDoc(file)
            })
        );
    };

    const handleDownloadAdditionalDoc = async (docId: number) => {
        setIsDownloadingAdditional(true);
        try {
            const response = await downloadDocumento({
                idVisita: selectedVisita.id,
                idDocumento: docId
            }).unwrap();

            const url = response.data.presignedUrl;
            window.open(url, '_blank');
        } catch (e) {
            enqueueSnackbar(t('execution.snackbar.downloadDocumentError'), { variant: 'error' });
        } finally {
            setIsDownloadingAdditional(false);
        }
    };

    const handleDeleteAdditional = async (docId: number) => {
        setIsDeletingAdditional(true);
        try {
            await deleteAdditionalDocumento({
                idVisita: selectedVisita.id,
                idDocumento: docId
            }).unwrap();

            enqueueSnackbar(t('execution.snackbar.deleteDocumentSuccess'), { variant: 'success' });
            refetchVisita();
        } catch {
            enqueueSnackbar(t('execution.snackbar.deleteDocumentError'), { variant: 'error' });
        } finally {
            setIsDeletingAdditional(false);
        }
    };

    const handleUploadAdditionalDoc = async (file: File) => {
        setIsUploadDocumentAditional(true);
        try {
            await uploadDocument({ idVisita: selectedVisita.id, file }).unwrap();
            refetchVisita();
            enqueueSnackbar(t('execution.snackbar.uploadDocumentSuccess'), { variant: 'success' });
        } catch {
            enqueueSnackbar(t('execution.snackbar.uploadDocumentError'), { variant: 'error' });
        } finally {
            setIsUploadDocumentAditional(false);
        }
    };

    const handleActivityCompletionChange = (actividadId: number, isCompleted: boolean) => {
        setActivitiesCompletion((prev) => ({
            ...prev,
            [actividadId]: isCompleted
        }));
    };

    useEffect(() => {
        if (
            !isRgrl ||
            !isRgrlRecibido ||
            !rgrlActivity?.id ||
            !isRgrlPending ||
            rgrlAlreadyPresented
        ) {
            return;
        }

        const presentRgrl = async () => {
            try {
                await presentActivityRgrl({
                    idVisita: selectedVisita.id,
                    idActividad: rgrlActivity.id
                }).unwrap();

                setRgrlAlreadyPresented(true);

                enqueueSnackbar(t('execution.snackbar.rgrlPresentedSuccess'), {
                    variant: 'success'
                });

                refetchVisita();
            } catch {
                enqueueSnackbar(t('execution.snackbar.rgrlPresentedError'), {
                    variant: 'error'
                });
            }
        };

        presentRgrl();
    }, [
        isRgrl,
        isRgrlRecibido,
        rgrlActivity?.id,
        isRgrlPending,
        rgrlAlreadyPresented,
        presentActivityRgrl,
        selectedVisita?.id,
        enqueueSnackbar,
        refetchVisita,
        t
    ]);

    const idPresentacion = rgrlPresentaciones?.length ? rgrlPresentaciones[0].id : null;

    const hasRgrlPresented = Boolean(idPresentacion);

    useEffect(() => {
        if (
            !isRgrlPresented ||
            !shouldPresentVerosimilitudActivity({
                isVerosimilitud,
                isVerosimilitudPresented,
                verosimilitudActivity,
                isVerosimilitudPending,
                verosimilitudAlreadyPresented
            })
        ) {
            return;
        }

        const presentVerosimilitud = async () => {
            try {
                await presentActivityVerosimilitud({
                    idVisita: selectedVisita.id,
                    idActividad: verosimilitudActivity.id
                }).unwrap();

                setVerosimilitudAlreadyPresented(true);
                refetchVisita();
            } catch {
                enqueueSnackbar(t('execution.snackbar.verosimilitudPresentedError'), {
                    variant: 'error'
                });
            }
        };

        presentVerosimilitud();
    }, [
        rgrlAlreadyPresented,
        isVerosimilitud,
        isVerosimilitudPresented,
        isVerosimilitudPending,
        verosimilitudAlreadyPresented,
        isRgrlPresented,
        presentActivityVerosimilitud,
        refetchVisita,
        selectedVisita?.id,
        enqueueSnackbar,
        t,
        verosimilitudActivity
    ]);

    useEffect(() => {
        if (!showPreventorImage) {
            setTimeout(() => {
                initPreventorSignaturePadRef.current();
            }, 0);
        }
    }, [showPreventorImage]);

    useEffect(() => {
        if (!showResponsableImage && (!isCPEOrganismo || firmaResponsableEnCanvasFallida)) {
            setTimeout(() => {
                initResponsableSignaturePadRef.current();
            }, 0);
        }
    }, [showResponsableImage, isCPEOrganismo, firmaResponsableEnCanvasFallida]);

    return (
        <>
            <SectionHeader>
                <SectionHeader.Title>
                    {t('newVisit.detail')} :{' '}
                    {siniestroNumber
                        ? `Siniestro Nro: ${siniestroNumber}`
                        : selectedVisita.nombreEstablecimiento ||
                          selectedVisita?.establecimiento?.nombre ||
                          '-'}
                </SectionHeader.Title>

                <SectionHeader.IconHeader
                    showIcon={false}
                    variant="outlined"
                    text={t('newVisit.establishment')}
                    onClick={handleOpenDrawer}
                    fullwidth
                />

                {siniestro?.id && (
                    <SectionHeader.IconHeader
                        showIcon={false}
                        variant="outlined"
                        text="Sobre el siniestro"
                        onClick={abrirDrawerSiniestro}
                        fullwidth
                    />
                )}

                <Box sx={{ p: 2 }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} gap={2}>
                        <Typography variant="h3">
                            <strong>Datos de la visita</strong>
                        </Typography>
                        {selectedVisita?.estado !== undefined && (
                            <VisitaEstadoChip
                                estadoId={selectedVisita.estado}
                                observacion={selectedVisita.observacion}
                                motivoFalla={selectedVisita.motivoFalla}
                            />
                        )}
                    </Box>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Establecimiento</strong></Typography>
                            <Typography variant="body2">
                                {formatTextOrDash(selectedVisita.nombreEstablecimiento || selectedVisita?.establecimiento?.nombre)}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Condición</strong></Typography>
                            <Typography variant="body2">
                                {formatTextOrDash(resolveEstablishmentCondition(establecimientoDetalle))}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Localidad / Provincia</strong></Typography>
                            <Typography variant="body2">{getLocalidadProvincia()}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Cliente</strong></Typography>
                            <Typography variant="body2">{getCliente()}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Tipo de visita</strong></Typography>
                            <Typography variant="body2">
                                {selectedVisita?.actividades?.length
                                    ? selectedVisita.actividades
                                          .map(
                                              (a: any) =>
                                                  VISIT_TYPE_DISPLAY_NAME_OVERRIDES[a.tipoVisita?.id] ||
                                                  a.tipoVisita?.descripcion?.toUpperCase()
                                          )
                                          .filter(Boolean)
                                          .join(', ') || '-'
                                    : '-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Preventor</strong></Typography>
                            <Typography variant="body2">{getPreventor()}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Fecha límite</strong></Typography>
                            <Typography variant="body2">{formatDateOrDash(selectedVisita.fechaLimite)}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Fecha estimada</strong></Typography>
                            <Typography variant="body2">{formatDateOrDash(selectedVisita.fechaProgramada || selectedVisita.fechaEstimada)}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Fecha de visita</strong></Typography>
                            <Typography variant="body2">{formatDateOrDash(selectedVisita.fechaVisita)}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Siniestro asociado</strong></Typography>
                            <Typography variant="body2">{formatTextOrDash(siniestroNumber)}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>CUIL</strong></Typography>
                            <Typography variant="body2">{formatTextOrDash(getCuilSiniestrado())}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Typography variant="h6"><strong>Nombre y Apellido</strong></Typography>
                            <Typography variant="body2">{formatTextOrDash(getNombreSiniestrado())}</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6"><strong>{t('filters.observations')}</strong></Typography>
                            <Typography variant="body2">{displayedHeaderObservation || '-'}</Typography>
                            {shouldTruncateHeaderObservation && (
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => setIsHeaderObservationExpanded((prev) => !prev)}
                                    sx={{ minWidth: 'auto', p: 0, mt: 0.5, textTransform: 'none' }}
                                >
                                    {isHeaderObservationExpanded ? 'Ver menos' : 'Ver mas'}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Box>

                {selectedVisita?.siniestro?.id && (
                    <Grid container sx={{ px: 2, pb: 2 }}>
                        <Grid item xs={12} sm={3} sx={{ pr: 2 }}>
                            <Typography variant="h6">
                                <strong>Nro ROAM</strong>
                            </Typography>
                            <Typography variant="body2">
                                {selectedVisita.siniestro?.nroRoam ?? '-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography variant="h6">
                                <strong>Lugar de ocurrencia</strong>
                            </Typography>
                            <Typography variant="body2">
                                {(() => {
                                    const lugar = selectedVisita.siniestro?.lugarOcurrencia ?? datosSiniestro?.lugarOcurrencia;
                                    return lugar
                                        ? [
                                              lugar.calle && lugar.altura
                                                  ? `${lugar.calle} ${lugar.altura}`
                                                  : lugar.calle,
                                              lugar.localidad?.nombre,
                                              lugar.localidad?.provincia?.nombre
                                          ]
                                              .filter(Boolean)
                                              .join(', ') || '-'
                                        : '-';
                                })()}
                            </Typography>
                        </Grid>
                    </Grid>
                )}
            </SectionHeader>

            {showBackofficeReturnBanner && (
                <AlertComponent
                    sx={{ mt: 4 }}
                    severity="warning"
                    message="Visita devuelta por el BackOffice"
                    content={<Typography variant="body2">{backofficeReturnMotive}</Typography>}
                    hideClose
                />
            )}

            {showObservacionesBackoffice && (
                <AlertComponent
                    sx={{ mt: 4 }}
                    severity="warning"
                    message="Observaciones Backoffice"
                    content={
                        <Typography variant="body2">
                            {selectedVisita.observacionRevision}
                        </Typography>
                    }
                    hideClose
                />
            )}

            {showNotaDevolucion && (
                <AlertComponent
                    sx={{ mt: 4 }}
                    severity="warning"
                    message={'Nota de devoluci\u00F3n'}
                    content={
                        <Typography variant="body2">
                            {selectedVisita.notaDevolucion}
                        </Typography>
                    }
                    hideClose
                />
            )}

            {selectedVisita?.motivoFalla != null && (
                <AlertComponent
                    sx={{ mt: 4 }}
                    severity="warning"
                    message={t('execution.detail.failureDetailTitle')}
                    content={
                        <>
                            <Typography variant="body2">
                                <strong>{t('execution.detail.failureDetailReason')}:</strong>{' '}
                                {selectedVisita.motivoFalla.descripcion}
                            </Typography>
                            {Boolean(selectedVisita.observacionFalla?.trim()) && (
                                <Typography variant="body2">
                                    <strong>{t('execution.detail.failureDetailObservation')}:</strong>{' '}
                                    {selectedVisita.observacionFalla}
                                </Typography>
                            )}
                        </>
                    }
                    hideClose
                />
            )}

            {isReadOnlyView && (
                <Box sx={{ mt: 4, backgroundColor: 'white', p: 4 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                        <Typography variant="h3">
                            <strong>Acta de visita</strong>
                        </Typography>
                        {puedeDescargarActaSeguimientoVerosimilitud && (
                            <SectionHeader.IconHeader
                                text={t('execution.detail.downloadBlankActa')}
                                showIcon={false}
                                variant="outlined"
                                onClick={() => setDownloadActa(true)}
                            />
                        )}
                        {puedeDescargarActaSiniestro && !puedeDescargarActaSeguimientoVerosimilitud && (
                            <SectionHeader.IconHeader
                                text={t('table.actions.downloadActa')}
                                showIcon={false}
                                variant="outlined"
                                loading={descargandoActaSiniestro}
                                disabled={descargandoActaSiniestro}
                                onClick={descargarActaSiniestro}
                            />
                        )}
                    </Box>

                    {!hasRegisteredActa && (
                        <Typography variant="body2" sx={{ mb: 2, opacity: 0.7 }}>
                            Sin acta registrada aun
                        </Typography>
                    )}

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selectedVisita.motivoFalla != null}
                                        disabled
                                    />
                                }
                                label={t('newVisit.label.failedVisit')}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                label={t('newVisit.label.administrativeStaff')}
                                fullWidth
                                value={selectedVisita.administrativos ?? ''}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                label={t('newVisit.label.productionStaff')}
                                fullWidth
                                value={selectedVisita.personalProduccion ?? ''}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                label={t('newVisit.label.otherStaff')}
                                fullWidth
                                value={selectedVisita.otrosPersonal ?? ''}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                label={t('newVisit.label.totalStaff')}
                                fullWidth
                                value={selectedVisita.totalPersonal ?? ''}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                label={t('newVisit.label.safetyService')}
                                fullWidth
                                value={
                                    selectedVisita.seguridadHigiene
                                        ? t('newVisit.common.yes')
                                        : t('newVisit.common.no')
                                }
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                label={t('newVisit.label.professional')}
                                fullWidth
                                value={selectedVisita.profesional}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                label={t('newVisit.label.license')}
                                fullWidth
                                value={formatHySReadOnly(selectedVisita.matricula, selectedVisita.matriculaNoInforma)}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label={t('newVisit.label.hysEmail')}
                                fullWidth
                                value={formatHySReadOnly(selectedVisita.emailHys, selectedVisita.emailHysNoInforma)}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label={t('newVisit.label.establishmentDescription')}
                                fullWidth
                                multiline
                                rows={3}
                                value={selectedVisita.descripcionEstablecimiento?.trim() || ''}
                                InputLabelProps={{ shrink: true }}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                label={t('newVisit.label.observation')}
                                fullWidth
                                multiline
                                rows={6}
                                value={selectedVisita.observacion?.trim() || ''}
                                InputLabelProps={{ shrink: true }}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <EjecucionRecomendacionesSection
                                idVisita={selectedVisita.id}
                                isVerosimilitud={isVerosimilitud}
                                hasVerosimilitudEntity={hasVerosimilitudEntity}
                                idVerosimilitud={idVerosimilitud}
                                idPresentacion={idPresentacion}
                                hasTechnicalVisit={hasTechnicalVisit}
                                isTechnicalVisitDone={isTechnicalVisitDone}
                                idVisitaTecnica={idVisitaTecnica}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ mt: 1 }}>
                                <strong>{t('execution.interviewed.title')}</strong>
                            </Typography>
                        </Grid>

                        {INTERVIEWED_FIELDS.map(({ name, labelKey }) => (
                            <Grid item xs={12} sm={name === 'emailEntrevistado' ? 8 : 4} key={name}>
                                <TextField
                                    label={t(labelKey)}
                                    fullWidth
                                    value={
                                        selectedVisitaInterviewedData[
                                            name as keyof typeof selectedVisitaInterviewedData
                                        ] ?? ''
                                    }
                                    InputLabelProps={{ shrink: true }}
                                    disabled
                                />
                            </Grid>
                        ))}

                        {selectedVisita.firmaPreventor && (
                            <Grid item xs={12} sm={6}>
                                <Box
                                    component="img"
                                    src={selectedVisita.firmaPreventor}
                                    alt="Firma Preventor"
                                    // Ver comentario en el <img> equivalente mas abajo: si esta URL vuelve a
                                    // pedirse por fetch() (payload.firmaPreventor cae aca cuando formData no
                                    // trae nada, useEjecutionVisits.ts buildPatchPayload) sin crossOrigin el
                                    // <img> puede envenenar esa request con una respuesta cacheada sin CORS.
                                    crossOrigin="anonymous"
                                    sx={{
                                        width: '100%',
                                        height: 150,
                                        background: '#F6F6F6',
                                        border: '1px solid #ccc'
                                    }}
                                />
                                <Typography>{t('newVisit.label.preventorSignature*')}</Typography>
                                <Typography variant="body2">
                                    <strong>{t('execution.detail.clarification')}:</strong>{' '}
                                    {`${selectedVisita.preventor?.nombre ?? ''} ${selectedVisita.preventor?.apellido ?? ''}`.trim() || '-'}
                                </Typography>

                                <Typography variant="body2">
                                    <strong>{t('execution.detail.dni')}:</strong>{' '}
                                    {selectedVisita.dniPreventor || '-'}
                                </Typography>

                                <Typography variant="body2">
                                    <strong>{t('execution.detail.role')}:</strong>{' '}
                                    {selectedVisita.cargoPreventor || '-'}
                                </Typography>
                            </Grid>
                        )}

                        {(selectedVisita.firmaResponsable || isCPEOrganismo) && (
                            <Grid item xs={12} sm={6}>
                                {selectedVisita.firmaResponsable ? (
                                    <Box
                                        component="img"
                                        src={selectedVisita.firmaResponsable}
                                        alt="Firma Responsable"
                                        sx={{
                                            width: '100%',
                                            height: 150,
                                            background: '#F6F6F6',
                                            border: '1px solid #ccc'
                                        }}
                                    />
                                ) : (
                                    <Box
                                        component="img"
                                        src={
                                            facsimileOrganismoKey
                                                ? RESPONSABLE_FACSIMILE_IMAGES[facsimileOrganismoKey]
                                                : RESPONSABLE_FACSIMILE_IMAGES.cpe
                                        }
                                        alt="Firma Responsable"
                                        sx={{
                                            width: '100%',
                                            height: 150,
                                            objectFit: 'contain',
                                            background: '#F6F6F6',
                                            border: '1px solid #ccc'
                                        }}
                                    />
                                )}
                                <Typography>{t('newVisit.label.responsibleSignature')}</Typography>
                                <Typography variant="body2">
                                    <strong>{t('execution.detail.clarification')}:</strong>{' '}
                                    {selectedVisita.aclaracionResponsable || '-'}
                                </Typography>

                                <Typography variant="body2">
                                    <strong>{t('execution.detail.dni')}:</strong>{' '}
                                    {selectedVisita.dniResponsable || '-'}
                                </Typography>

                                <Typography variant="body2">
                                    <strong>{t('execution.detail.role')}:</strong>{' '}
                                    {selectedVisita.cargoResponsable || '-'}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </Box>
            )}

            {!isReadOnlyView && (
                <Box
                    component="div"
                    justifyContent="center"
                    sx={{ mt: 4, backgroundColor: 'white', p: 2 }}
                >
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                        <Typography variant="h3">
                            <strong>{t('newVisit.sectionSummary')}</strong>
                        </Typography>

                        <SectionHeader.IconHeader
                            text={t('execution.detail.downloadBlankActa')}
                            showIcon={false}
                            variant="outlined"
                            onClick={() => setDownloadActa(true)}
                        />
                    </Box>

                    <Grid container spacing={1} sx={{ p: 2 }}>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isFailedVisit}
                                        disabled={isReadOnlyView || isFailedVisitByState}
                                        onChange={handleFalloVisitaChange}
                                    />
                                }
                                label={t('newVisit.label.failedVisit')}
                            />
                        </Grid>

                        {formData.esFallida && (
                            <Grid item xs={12}>
                                <MotivoFallaSelector
                                    idMotivoFallaVisita={formData.idMotivoFallaVisita}
                                    motivosFallaOptions={motivosFallaOptions}
                                    loadingMotivosFalla={loadingMotivosFalla}
                                    disabled={isReadOnlyView}
                                    onChangeMotivo={(idMotivoFallaVisita) =>
                                        setFormData((prev: any) => ({
                                            ...prev,
                                            idMotivoFallaVisita
                                        }))
                                    }
                                />
                            </Grid>
                        )}

                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                label={t('newVisit.label.administrativeStaff')}
                                name="administrativos"
                                type="number"
                                value={formData.administrativos ?? ''}
                                onChange={handleChange}
                                disabled={formData.esFallida || isReadOnlyView}
                                inputProps={{ min: 0 }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                label={t('newVisit.label.productionStaff')}
                                name="personalProduccion"
                                type="number"
                                value={formData.personalProduccion ?? ''}
                                onChange={handleChange}
                                disabled={formData.esFallida || isReadOnlyView}
                                inputProps={{ min: 0 }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                label={t('newVisit.label.otherStaff')}
                                name="otrosPersonal"
                                type="number"
                                value={formData.otrosPersonal ?? ''}
                                onChange={handleChange}
                                disabled={formData.esFallida || isReadOnlyView}
                                inputProps={{ min: 0 }}
                            />
                        </Grid>

                        {/* El total lo calcula el sistema: Administrativos + Produccion + Otros. */}
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                label={t('newVisit.label.totalStaff')}
                                name="totalPersonal"
                                value={formData.totalPersonal ?? 0}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <InputLabel disabled={formData.esFallida || isReadOnlyView}>
                                    {t('newVisit.label.safetyService')}
                                </InputLabel>

                                <Select<boolean>
                                    name="seguridadHigiene"
                                    value={(formData.seguridadHigiene ?? '') as unknown as boolean}
                                    onChange={(event) => {
                                        if (isReadOnlyView) return;

                                        const value = event.target.value;
                                        setFormData((prev: any) => ({
                                            ...prev,
                                            seguridadHigiene: value,
                                            ...(value === false
                                                ? {
                                                      profesional: '',
                                                      matricula: '',
                                                      matriculaNoInforma: false,
                                                      emailHys: '',
                                                      emailHysNoInforma: false
                                                  }
                                                : {})
                                        }));
                                    }}
                                    disabled={formData.esFallida || isReadOnlyView}
                                >
                                    <MenuItem value={true as unknown as string}>
                                        {t('newVisit.common.yes')}
                                    </MenuItem>
                                    <MenuItem value={false as unknown as string}>
                                        {t('newVisit.common.no')}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                required={formData.seguridadHigiene === true}
                                label={t('newVisit.label.professional')}
                                name="profesional"
                                value={sinServicioHyS ? '-' : formData.profesional}
                                onChange={handleChange}
                                disabled={
                                    formData.esFallida ||
                                    formData.seguridadHigiene === false ||
                                    isReadOnlyView
                                }
                                error={
                                    submitAttempted &&
                                    formData.seguridadHigiene === true &&
                                    !formData.profesional?.trim()
                                }
                                helperText={
                                    submitAttempted &&
                                    formData.seguridadHigiene === true &&
                                    !formData.profesional?.trim()
                                        ? 'Campo requerido'
                                        : ''
                                }
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                fullWidth
                                required={formData.seguridadHigiene === true && !formData.matriculaNoInforma}
                                label={t('newVisit.label.license')}
                                name="matricula"
                                value={
                                    sinServicioHyS
                                        ? '-'
                                        : formData.matriculaNoInforma
                                          ? t('newVisit.label.notInformed')
                                          : formData.matricula
                                }
                                onChange={handleChange}
                                disabled={
                                    formData.esFallida ||
                                    sinServicioHyS ||
                                    formData.matriculaNoInforma ||
                                    isReadOnlyView
                                }
                                error={submitAttempted && faltaMatricula}
                                helperText={submitAttempted && faltaMatricula ? 'Campo requerido' : ''}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={Boolean(formData.matriculaNoInforma)}
                                        onChange={handleNoInformaChange('matricula')}
                                        disabled={formData.esFallida || !conServicioHyS || isReadOnlyView}
                                    />
                                }
                                label={t('newVisit.label.notInformed')}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                required={formData.seguridadHigiene === true && !formData.emailHysNoInforma}
                                type="email"
                                label={t('newVisit.label.hysEmail')}
                                name="emailHys"
                                placeholder="nombre@dominio.com"
                                value={
                                    sinServicioHyS
                                        ? '-'
                                        : formData.emailHysNoInforma
                                          ? t('newVisit.label.notInformed')
                                          : formData.emailHys
                                }
                                onChange={handleChange}
                                disabled={
                                    formData.esFallida ||
                                    sinServicioHyS ||
                                    formData.emailHysNoInforma ||
                                    isReadOnlyView
                                }
                                error={submitAttempted && Boolean(errorEmailHys)}
                                helperText={submitAttempted ? errorEmailHys : ''}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        checked={Boolean(formData.emailHysNoInforma)}
                                        onChange={handleNoInformaChange('emailHys')}
                                        disabled={formData.esFallida || !conServicioHyS || isReadOnlyView}
                                    />
                                }
                                label={t('newVisit.label.notInformed')}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label={t('newVisit.label.establishmentDescription')}
                                name="descripcionEstablecimiento"
                                value={formData.descripcionEstablecimiento ?? ''}
                                onChange={handleChange}
                                InputLabelProps={{ shrink: true }}
                                disabled={formData.esFallida || isReadOnlyView}
                                inputProps={{ maxLength: OBSERVATION_MAX_LENGTH }}
                                helperText={`${(formData.descripcionEstablecimiento ?? '').length}/${OBSERVATION_MAX_LENGTH}`}
                                FormHelperTextProps={{ sx: { textAlign: 'right' } }}
                            />
                        </Grid>
                        {selectedVisita?.nombreTipoVisita === 'GENERICA' && (
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    select
                                    fullWidth
                                    label={t('newVisit.label.subVisitType')}
                                    name="idSubTipoVisita"
                                    value={formData.idSubTipoVisita ?? ''}
                                    onChange={handleChange}
                                    disabled={loadingTiposVisitas || formData.esFallida}
                                >
                                    {loadingTiposVisitas ? (
                                        <MenuItem disabled></MenuItem>
                                    ) : (
                                        subTypesVisitasOptions.map((option: any) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.nombre}
                                            </MenuItem>
                                        ))
                                    )}
                                </TextField>
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                rows={6}
                                label={t('newVisit.label.observation')}
                                name="observacion"
                                value={formData.observacion}
                                onChange={handleChange}
                                InputLabelProps={{ shrink: true }}
                                disabled={isReadOnlyView}
                                error={submitAttempted && isFailedVisit && !hasFailedVisitObservacion}
                                inputProps={{ maxLength: OBSERVATION_MAX_LENGTH }}
                                helperText={`${formData.observacion.length}/${OBSERVATION_MAX_LENGTH}`}
                                FormHelperTextProps={{ sx: { textAlign: 'right' } }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <EjecucionRecomendacionesSection
                                idVisita={selectedVisita.id}
                                isVerosimilitud={isVerosimilitud}
                                hasVerosimilitudEntity={hasVerosimilitudEntity}
                                idVerosimilitud={idVerosimilitud}
                                idPresentacion={idPresentacion}
                                hasTechnicalVisit={hasTechnicalVisit}
                                isTechnicalVisitDone={isTechnicalVisitDone}
                                idVisitaTecnica={idVisitaTecnica}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ mt: 2 }}>
                                <strong>{t('execution.interviewed.title')}</strong>
                            </Typography>
                        </Grid>

                        {INTERVIEWED_FIELDS.map(({ name, labelKey, maxLength, validations }) => (
                            <Grid item xs={12} sm={name === 'emailEntrevistado' ? 8 : 4} key={name}>
                                <TextField
                                    fullWidth
                                    required={!formData.esFallida && validations.some((v) => v.name === 'required')}
                                    label={t(labelKey)}
                                    name={name}
                                    type={name === 'emailEntrevistado' ? 'email' : 'text'}
                                    value={formDataByName[name] ?? ''}
                                    onChange={handleChange}
                                    // En la fallida son opcionales (SMP-416): solo se marca el
                                    // formato de lo que se cargue, nunca el requerido.
                                    disabled={isReadOnlyView}
                                    error={submitAttempted && Boolean(interviewedFieldError(name))}
                                    helperText={submitAttempted ? interviewedFieldError(name) : ''}
                                    inputProps={{
                                        maxLength,
                                        ...(name === 'telefonoEntrevistado'
                                            ? { inputMode: 'numeric', pattern: '[0-9]*' }
                                            : {})
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>

                    <Grid container spacing={0} sx={{ p: 2 }} justifyContent="space-between">
                        <Grid
                            item
                            xs={12}
                            sm={5.8}
                            sx={{ p: 2, borderRadius: '5px', border: '1px solid #0000003b' }}
                        >
                            {showPreventorImage ? (
                                <>
                                    <Box
                                        component="img"
                                        src={preventorSignatureImageSrc}
                                        alt="Firma Preventor"
                                        // Esta misma URL (presignada de S3) se vuelve a pedir con fetch() al
                                        // guardar/ejecutar (ver signatureUrlToBase64 en facsimileSignature.ts)
                                        // para convertirla a base64. Sin crossOrigin, Chrome cachea la respuesta
                                        // de este <img> como "opaca" (sin headers CORS) y ese fetch posterior
                                        // reutiliza esa entrada de cache en vez de ir a la red, lo que rompe
                                        // el chequeo de CORS aunque el bucket este bien configurado.
                                        crossOrigin="anonymous"
                                        sx={{
                                            width: '100%',
                                            height: 150,
                                            objectFit: 'contain',
                                            background: '#F6F6F6',
                                            borderBottom: '1px solid #000'
                                        }}
                                    />

                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        mt={1}
                                    >
                                        <Typography variant="body2">
                                            {t('newVisit.label.preventorSignature')}
                                        </Typography>

                                        {!isReadOnlyView && (
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() => {
                                                    setEditPreventorSignature(true);
                                                    setFormData((prev: any) => ({
                                                        ...prev,
                                                        firmaPreventor: ''
                                                    }));
                                                }}
                                            >
                                                {t('newVisit.common.clear')}
                                            </Button>
                                        )}
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <canvas
                                        ref={canvasPreventorRef}
                                        style={{
                                            width: '100%',
                                            height: '150px',
                                            borderBottom: '1px solid #000',
                                            background: canSignPreventor ? '#F6F6F6' : '#E0E0E0',
                                            pointerEvents: canSignPreventor ? 'auto' : 'none'
                                        }}
                                    />

                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        mt={1}
                                    >
                                        <Typography variant="body2">
                                            {t('newVisit.label.preventorSignature')}
                                        </Typography>

                                        <Button
                                            onClick={() => handleClearSignature('preventor')}
                                            variant="outlined"
                                            disabled={isReadOnlyView}
                                        >
                                            {t('newVisit.common.clear')}
                                        </Button>
                                    </Box>

                                    {signatureErrors.firmaPreventor && (
                                        <Typography variant="body2" color="error">
                                            {t('newVisit.enqueue.signatureError')}
                                        </Typography>
                                    )}
                                </>
                            )}

                            <SignatureExtraFields
                                clarificationName="aclaracionPreventor"
                                dniName="dniPreventor"
                                roleName="cargoPreventor"
                                values={formData}
                                onChange={handleChange}
                                disabled={isReadOnlyView}
                                clarificationError={
                                    submitAttempted &&
                                    isFailedVisit &&
                                    !formData.aclaracionPreventor?.trim()
                                }
                                dniError={
                                    submitAttempted && isFailedVisit && !formData.dniPreventor?.trim()
                                }
                                roleError={
                                    submitAttempted && isFailedVisit && !formData.cargoPreventor?.trim()
                                }
                            />
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            sm={5.8}
                            sx={{ p: 2, borderRadius: '5px', border: '1px solid #0000003b' }}
                        >
                            {showResponsableImage ? (
                                <>
                                    <Box
                                        component="img"
                                        src={selectedVisita.firmaResponsable}
                                        alt="Firma Responsable"
                                        sx={{
                                            width: '100%',
                                            height: 150,
                                            objectFit: 'contain',
                                            background: '#F6F6F6',
                                            borderBottom: '1px solid #000'
                                        }}
                                    />

                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        mt={1}
                                    >
                                        <Typography variant="body2">
                                            {t('newVisit.label.responsibleSignature')}
                                        </Typography>

                                        {!isReadOnlyView && (
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={async () => {
                                                    setEditResponsableSignature(true);

                                                    const firmaResponsable = facsimileOrganismoKey
                                                        ? await buildResponsableFacsimileImage(
                                                              facsimileOrganismoKey
                                                          )
                                                        : '';

                                                    setFormData((prev: any) => ({
                                                        ...prev,
                                                        firmaResponsable
                                                    }));
                                                }}
                                            >
                                                {t('newVisit.common.clear')}
                                            </Button>
                                        )}
                                    </Box>
                                </>
                            ) : isCPEOrganismo && !firmaResponsableEnCanvasFallida ? (
                                <>
                                    {formData.firmaResponsable ? (
                                        <Box
                                            component="img"
                                            src={`data:image/png;base64,${formData.firmaResponsable}`}
                                            alt="Firma Responsable"
                                            sx={{
                                                width: '100%',
                                                height: 150,
                                                objectFit: 'contain',
                                                background: '#F6F6F6',
                                                borderBottom: '1px solid #000'
                                            }}
                                        />
                                    ) : (
                                        <Box
                                            sx={{
                                                width: '100%',
                                                height: 150,
                                                background: '#F6F6F6',
                                                borderBottom: '1px solid #000'
                                            }}
                                        />
                                    )}

                                    <Box mt={1}>
                                        <Typography variant="body2">
                                            {t('newVisit.label.responsibleSignature')}
                                        </Typography>
                                    </Box>
                                </>
                            ) : (
                                <>
                                    <canvas
                                        ref={canvasResponsableRef}
                                        style={{
                                            width: '100%',
                                            height: '150px',
                                            borderBottom: '1px solid #000',
                                            background: canSignResponsable ? '#F6F6F6' : '#E0E0E0',
                                            pointerEvents: canSignResponsable ? 'auto' : 'none'
                                        }}
                                    />

                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        mt={1}
                                    >
                                        <Typography variant="body2">
                                            {t('newVisit.label.responsibleSignature')}
                                        </Typography>

                                        <Button
                                            onClick={() => handleClearSignature('responsable')}
                                            variant="outlined"
                                            disabled={isReadOnlyView}
                                        >
                                            {t('newVisit.common.clear')}
                                        </Button>
                                    </Box>

                                    {signatureErrors.firmaResponsable && (
                                        <Typography variant="body2" color="error">
                                            {t('newVisit.enqueue.signatureError')}
                                        </Typography>
                                    )}
                                </>
                            )}

                            <SignatureExtraFields
                                clarificationName="aclaracionResponsable"
                                dniName="dniResponsable"
                                roleName="cargoResponsable"
                                values={formData}
                                onChange={handleChange}
                                disabled={isReadOnlyView}
                            />
                        </Grid>
                    </Grid>
                </Box>
            )}

            {shouldShowActivitiesSection && (
                <Box
                    component="div"
                    justifyContent="center"
                    sx={{ mt: 4, backgroundColor: 'white', p: 2 }}
                >
                    <Typography variant="h3">
                        <strong>{t('newVisit.activities')}</strong>
                    </Typography>
                    {(isVerosimilitud || isRgrl || hasTechnicalVisit || esVisitaInvestigacion) && (
                        <Grid container spacing={1} sx={{ p: 2 }}>
                            {isVerosimilitud && !loadingPresentaciones && !hasRgrlPresented && (
                                <Alert
                                    severity="warning"
                                    variant="outlined"
                                    sx={{
                                        mt: 2,
                                        fontSize: 13,
                                        alignItems: 'center'
                                    }}
                                >
                                    {t('newVisit.error.notRGRL')}
                                </Alert>
                            )}
                            {isVerosimilitud && (
                                <VerosimilitudSection
                                    isVerosimilitudDraft={isVerosimilitudDraft}
                                    rgrlPresentaciones={rgrlPresentaciones}
                                    isFailedVisit={isFailedVisit}
                                    isVerosimilitudPendienteSinRespuestas={
                                        isVerosimilitudPendienteSinRespuestas
                                    }
                                    selectedVisita={selectedVisita}
                                    shouldShowVerosimilitudRow={shouldShowVerosimilitudRow}
                                    handleOpenVerosimilitud={handleOpenVerosimilitud}
                                    hasRgrlPresentations={hasRgrlPresentations()}
                                    loadingVerosimilitud={loadingVerosimilitud}
                                    loadingRgrl={loadingPresentaciones}
                                    isReadOnly={isReadOnlyView}
                                />
                            )}

                            {isRgrl && (
                                <RGRLSection
                                    rgrlPresentaciones={rgrlPresentaciones}
                                    isFailedVisit={isFailedVisit}
                                    loadingPresentaciones={loadingPresentaciones}
                                    allPresentationsCancelled={allPresentationsCancelled}
                                    handleOpenDialogRGRL={handleOpenDialogRGRL}
                                    handleCardClickRGRL={handleCardClickRGRL}
                                    confirmCancelPresentation={confirmCancelPresentation}
                                    handleEditRGRL={handleEditRGRL}
                                    onRgrlStatusChange={setIsRgrlRecibido}
                                    isReadOnly={isReadOnlyView}
                                    esAutoseguro={isAutoseguro(getCliente())}
                                />
                            )}

                            {hasTechnicalVisit && (
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        borderBottom: '1px solid #ccc',
                                        padding: '12px 8px'
                                    }}
                                >
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <Typography
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: 700,
                                                textTransform: 'uppercase'
                                            }}
                                        >
                                            {t('technicalVisit.formActivityTitle')}
                                        </Typography>
                                        <ActivitySummaryChip
                                            status={
                                                technicalVisitActivity?.estado === 2
                                                    ? 'DONE'
                                                    : 'PENDING'
                                            }
                                        />
                                    </Box>

                                    <Box display="flex" gap={1}>
                                        {isTechnicalVisitDone ? (
                                            <>
                                                {!isAdminBO && (
                                                    // Realizada: se edita solo mientras la visita siga abierta
                                                    // para el preventor (p. ej. En proceso); en revisión o
                                                    // cerrada queda en solo lectura (SMP-370).
                                                    <IconButton
                                                        aria-label={String(
                                                            t('technicalVisit.formActivityTitle')
                                                        )}
                                                        onClick={() =>
                                                            handleOpenTechnicalVisit(
                                                                isReadOnlyView ? 'view' : 'edit'
                                                            )
                                                        }
                                                        disabled={isProvider}
                                                    >
                                                        {isReadOnlyView ? <VisibilityIcon /> : <EditIcon />}
                                                    </IconButton>
                                                )}
                                                <IconButton
                                                    aria-label={String(
                                                        t('technicalVisit.form.downloadPdf')
                                                    )}
                                                    onClick={handleDownloadTechnicalVisit}
                                                >
                                                    <FileDownloadIcon />
                                                </IconButton>
                                            </>
                                        ) : (
                                            <IconButton
                                                aria-label={String(
                                                    t('technicalVisit.formActivityTitle')
                                                )}
                                                onClick={() =>
                                                    handleOpenTechnicalVisit(
                                                        isReadOnlyRole ? 'view' : 'edit'
                                                    )
                                                }
                                                disabled={(isReadOnlyView && !isReadOnlyRole) || isProvider}
                                            >
                                                {isReadOnlyRole ? <VisibilityIcon /> : <EditIcon />}
                                            </IconButton>
                                        )}
                                    </Box>
                                </Box>
                            )}

                            {esVisitaInvestigacion && selectedVisita?.siniestro?.id && (
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        borderBottom: '1px solid #ccc',
                                        padding: '12px 8px'
                                    }}
                                >
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <Typography
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: 700,
                                                textTransform: 'uppercase'
                                            }}
                                        >
                                            Investigacion de accidentes
                                        </Typography>
                                        <ActivitySummaryChip
                                            status={
                                                investigacionActivity?.estado === 2
                                                    ? 'DONE'
                                                    : 'PENDING'
                                            }
                                        />
                                    </Box>
                                    <Box display="flex" gap={1}>
                                        {puedeDescargarPdfInvestigacionVisita && (
                                            <Tooltip title={t('table.actions.downloadPdfInvestigacion')}>
                                                <span>
                                                    <IconButton
                                                        aria-label={String(
                                                            t('table.actions.downloadPdfInvestigacion')
                                                        )}
                                                        onClick={() =>
                                                            descargarPdfInvestigacion(selectedVisita)
                                                        }
                                                        disabled={descargandoPdfInvestigacion}
                                                    >
                                                        {descargandoPdfInvestigacion ? (
                                                            <CircularProgress size={20} />
                                                        ) : (
                                                            <PictureAsPdfOutlinedIcon />
                                                        )}
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        )}
                                        <IconButton
                                            aria-label="Abrir formulario SRT"
                                            onClick={handleAbrirFormularioSRT}
                                            disabled={!effectiveReadOnlySrt && !!isReadOnlyView}
                                        >
                                            {effectiveReadOnlySrt ? <VisibilityIcon /> : <EditIcon />}
                                        </IconButton>
                                    </Box>
                                </Box>
                            )}
                        </Grid>
                    )}
                    {renderableOtherActivities.length > 0 && (
                        <Grid container spacing={1}>
                            {renderableOtherActivities.length > 0 && (
                                <Grid container spacing={1} sx={{ pl: 3 }}>
                                    {renderableOtherActivities.map(
                                        (actividad: ActividadItem, index: number) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <ActivityActionsMenu
                                                    isFailedVisit={isFailedVisit}
                                                    idVisita={selectedVisita.id}
                                                    actividad={actividad}
                                                    shouldUpdateFechaVisitaOnDocumentUpload={
                                                        shouldUpdateFechaVisitaOnDocumentUpload
                                                    }
                                                    disableFunctionality={isReadOnlyView}
                                                    tipoActividad={getTipoActividad(
                                                        actividad.tipoVisita.id
                                                    )}
                                                    refetchVisita={refetchVisita}
                                                    onCompletionChange={
                                                        handleActivityCompletionChange
                                                    }
                                                    onOpenForm={
                                                        isPreventor &&
                                                        !isReadOnlyView &&
                                                        actividad.tipoVisita.descripcion
                                                            .toUpperCase()
                                                            .includes('SEGUIMIENTO VEROSIMILITUD')
                                                            ? handleAbrirSeguimientoVerosimilitud
                                                            : undefined
                                                    }
                                                    canDownloadSeguimiento={esEstadoDescargaActaPermitido(
                                                        selectedVisita?.estado,
                                                        selectedVisita?.actaVerosimilitudDisponiblePorDatos
                                                    )}
                                                    canEditSeguimiento={[
                                                        VisitaEstado.PENDIENTE,
                                                        VisitaEstado.PROGRAMADA,
                                                        VisitaEstado.EN_PROCESO
                                                    ].includes(selectedVisita?.estado)}
                                                />
                                            </Box>
                                        )
                                    )}
                                </Grid>
                            )}
                        </Grid>
                    )}
                </Box>
            )}

            <Box
                component="div"
                justifyContent="center"
                sx={{ mt: 4, backgroundColor: 'white', p: 2 }}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 3 }}
                >
                    <Typography variant="h3">
                        <strong>{t('execution.detail.additionalDocumentationTitle')}</strong>
                    </Typography>

                    {!isReadOnlyRole && (
                        <Button
                            disabled={isReadOnlyView}
                            variant="outlined"
                            startIcon={<UploadFileIcon />}
                            component="label"
                        >
                            {t('execution.detail.attachAdditionalDocumentation')}
                            <input
                                type="file"
                                hidden
                                accept="application/pdf,image/*"
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) confirmUploadAdditionalDoc(file);
                                }}
                            />
                        </Button>
                    )}
                </Box>

                {loadingAdditionalDocs ? (
                    <Typography variant="body2">
                        {t('execution.detail.loadingDocuments')}
                    </Typography>
                ) : additionalDocuments.length === 0 ? (
                    <Typography variant="body2" sx={{ opacity: 0.6 }}>
                        {t('execution.detail.noAttachedDocuments')}
                    </Typography>
                ) : (
                    <Box>
                        {additionalDocuments.map((doc: any) => (
                            <Box
                                key={doc.id}
                                sx={{
                                    borderBottom: '1px solid #ccc',
                                    padding: '10px 4px',
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 0.8fr auto',
                                    alignItems: 'center'
                                }}
                            >
                                <Typography sx={{ fontWeight: 500 }}>
                                    {getFileName(doc.path)}
                                </Typography>

                                <Box display="flex" gap={1} justifyContent="flex-end">
                                    <IconButton onClick={() => handleDownloadAdditionalDoc(doc.id)}>
                                        <FileDownloadIcon />
                                    </IconButton>

                                    {!isReadOnlyRole && (
                                        <IconButton
                                            disabled={isReadOnlyView}
                                            onClick={() => handleDeleteAdditional(doc.id)}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    )}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, p: 2 }}>
                <Button variant="text" onClick={() => navigate(-1)}>
                    {t('buttons.goBack')}
                </Button>

                {!isReadOnlyView && (
                    <Box display="flex" gap={2}>
                        <Button variant="outlined" color="primary" onClick={handleSaveInProgress}>
                            {t('execution.detail.saveProgress')}
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleConfirmSubmitClick}
                        >
                            {t('newVisit.common.send')}
                        </Button>
                    </Box>
                )}

                {isAdminBO && selectedVisita?.estado === VisitaEstado.REALIZADA && (
                    <Box display="flex" gap={2}>
                        <Button variant="outlined" onClick={() => setIsSendToPreventorOpen(true)}>
                            {t('table.actions.sendToRevision')}
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={isApprovingVisit}
                            onClick={handleApproveVisitClick}
                        >
                            {t('execution.detail.approveVisit')}
                        </Button>
                    </Box>
                )}
            </Box>

            {/* Sin DrawerManager: define el contenido como componente interno y lo
                remonta en cada render de esta pantalla, que se re-renderiza seguido
                (se perdería el motivo mientras se escribe). */}
            <DrawerContainer
                open={isSendToPreventorOpen}
                setOpen={setIsSendToPreventorOpen}
                onClose={() => setIsSendToPreventorOpen(false)}
                customWidth={700}
            >
                <SendVisitToRevisionDrawer
                    translate={t}
                    selected={selectedVisita}
                    setOpen={setIsSendToPreventorOpen}
                    onSuccess={refetchVisita}
                    actionType={DRAWER_ACTION_VALUES.SEND_VISIT_TO_REVISION}
                />
            </DrawerContainer>
            <DrawerVisitas
                open={openDrawer}
                setOpen={setOpenDrawer}
                actionType={DRAWER_ACTION_VALUES.ESTABLISHMENT}
                visita={selectedVisitaDetail}
            />
            <SobreSiniestroDrawer
                abierto={drawerSiniestroAbierto}
                onCerrar={cerrarDrawerSiniestro}
                datos={datosSiniestro}
                cargando={cargandoSiniestro}
                error={errorSiniestro}
                esPreventor={Boolean(isPreventor)}
            />
            <DialogNewRGRL
                open={openDialogRGRL}
                handleClose={handleCloseDialogRGRL}
                handleCardClick={() => {}}
                handleCardClickRGRL={handleCardClickRGRL}
            />
            <BackdropComponent
                loading={
                    isDownloadingAdditional ||
                    isDeletingAdditional ||
                    isUploadDocumentAditional ||
                    isSavingInProgress ||
                    isDownloadingActa ||
                    isDownloadingTechnicalVisit
                }
                zIndex={3000}
            />
        </>
    );
}

export default EjecutionsVisitsIndex;
